import ScalarIconTextAlignLeft_vue_vue_type_script_setup_true_lang_default from "./ScalarIconTextAlignLeft.vue.script.js";
//#region src/components/ScalarIconTextAlignLeft.vue
var ScalarIconTextAlignLeft_default = ScalarIconTextAlignLeft_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconTextAlignLeft_default as default };

//# sourceMappingURL=ScalarIconTextAlignLeft.js.map